import ScrollAnimation from 'react-animate-on-scroll'

type Props = {
  initiallyVisible?: boolean
}

export function HumaScrollAnimation({
  initiallyVisible = false,
  children,
}: React.PropsWithChildren<Props>) {
  return (
    <ScrollAnimation
      duration={0.5}
      initiallyVisible={initiallyVisible}
      animateIn='fade-in-up'
      animateOnce={true}
    >
      {children}
    </ScrollAnimation>
  )
}
